/* global Elm */
import { initPorts } from '../../../../EngageCore.Commerce/Controls/Checkout/main.mjs';

import { defineInputMoney } from '../../../../EngageCore.Membership/Elm/Engage/Membership/Configuration/inputMoney.mjs';

defineInputMoney();

let recaptchaWidgetId = null;

/**
 *
 * @param {*} args The arguments
 */
export function init(args) {
	const app = Elm.Views.Payment.Main.init(args);

	initPorts(app, args.flags.paymentProcessor);

	app.ports.initRecaptcha.subscribe((recaptchaArgs) => {
		const recaptchaLoadTimeout = 1000;
		const [containerId, recaptchaKey] = recaptchaArgs;
		setTimeout(() => {
			recaptchaWidgetId = window.grecaptcha?.enterprise?.render(
				containerId,
				{
					action: 'payment_submit',
					sitekey: recaptchaKey,
					theme: 'light',
				},
			);
		}, recaptchaLoadTimeout);
	});

	app.ports.getRecaptchaSubmitResponse.subscribe(() => {
		let response = null;
		if (recaptchaWidgetId !== null) {
			response =
				window.grecaptcha?.enterprise?.getResponse(recaptchaWidgetId);
		}

		app.ports.gotRecaptchaSubmitResponse.send(response);
	});

	app.ports.getRecaptchaPayResponse.subscribe(() => {
		let response = null;
		if (recaptchaWidgetId !== null) {
			response =
				window.grecaptcha?.enterprise?.getResponse(recaptchaWidgetId);
		}

		app.ports.gotRecaptchaPayResponse.send(response);
	});
}
